import { useState } from "react";
import axios from "axios";

const LAYOUT_KEY = "pickup_area_layout";

export default function useFrontendLayoutConfig({ apiBaseUrl }) {
  const [layoutConfig, setLayoutConfig] = useState({ rows: [] });
  const [layoutLoading, setLayoutLoading] = useState(false);

  const fetchLayoutConfig = async () => {
    setLayoutLoading(true);
    try {
      const response = await axios.get(`${apiBaseUrl}/config/frontend-layout/${LAYOUT_KEY}`);
      setLayoutConfig(response.data);
    } catch (error) {
      console.error("获取布局配置失败", error);
    } finally {
      setLayoutLoading(false);
    }
  };

  const saveLayoutConfig = async () => {
    try {
      setLayoutLoading(true);
      await axios.put(`${apiBaseUrl}/admin/config/frontend-layout/${LAYOUT_KEY}`, {
        rows: layoutConfig.rows
      });
      alert("布局配置保存成功！");
    } catch (error) {
      alert("保存失败: " + (error.response?.data?.detail || error.message));
    } finally {
      setLayoutLoading(false);
    }
  };

  const addAreaToRow = (rowIndex, areaCode) => {
    const newRows = [...layoutConfig.rows];
    if (!newRows[rowIndex].areas.includes(areaCode)) {
      newRows[rowIndex].areas.push(areaCode);
      setLayoutConfig({ ...layoutConfig, rows: newRows });
    }
  };

  const removeAreaFromRow = (rowIndex, areaCode) => {
    const newRows = [...layoutConfig.rows];
    newRows[rowIndex].areas = newRows[rowIndex].areas.filter(a => a !== areaCode);
    setLayoutConfig({ ...layoutConfig, rows: newRows });
  };

  const addLayoutRow = () => {
    setLayoutConfig({
      ...layoutConfig,
      rows: [...layoutConfig.rows, { areas: [], label: "" }]
    });
  };

  const removeLayoutRow = (rowIndex) => {
    const newRows = layoutConfig.rows.filter((_, i) => i !== rowIndex);
    setLayoutConfig({ ...layoutConfig, rows: newRows });
  };

  const moveAreaUp = (rowIndex, areaCode) => {
    if (rowIndex === 0) return;
    const newRows = [...layoutConfig.rows];
    newRows[rowIndex].areas = newRows[rowIndex].areas.filter(a => a !== areaCode);
    newRows[rowIndex - 1].areas.push(areaCode);
    setLayoutConfig({ ...layoutConfig, rows: newRows });
  };

  const moveAreaDown = (rowIndex, areaCode) => {
    if (rowIndex === layoutConfig.rows.length - 1) return;
    const newRows = [...layoutConfig.rows];
    newRows[rowIndex].areas = newRows[rowIndex].areas.filter(a => a !== areaCode);
    newRows[rowIndex + 1].areas.push(areaCode);
    setLayoutConfig({ ...layoutConfig, rows: newRows });
  };

  return {
    addAreaToRow,
    addLayoutRow,
    fetchLayoutConfig,
    layoutConfig,
    layoutLoading,
    moveAreaDown,
    moveAreaUp,
    removeAreaFromRow,
    removeLayoutRow,
    saveLayoutConfig,
  };
}
